import React, { useCallback, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { joiResolver } from "@hookform/resolvers/joi";
import { get, size } from "lodash";
import {
  Button,
  Grid,
  Typography,
  TextField,
  Stack,
  Divider,
  FormControlLabel,
  Checkbox,
  IconButton,
} from "@mui/material";
import { useSnackbar } from "notistack";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import Iconify from "../../components/iconify/iconify";
import CustomPopover from "../../components/custom-popover/custom-popover";
import usePopover from "../../components/custom-popover/use-popover";
import { Box } from "@mui/system";
import { useDoctorForm } from "../../data/talons/Doctor/useDoctorForm";
import { color } from "../../utils/constant";
import { useProfileForm } from "../../data/talons/Profile/useProfileForm";

/*
 * Render Real - Estate Inquiry Form screen
 *
 *
 */

export default function ProfileForm(props) {
  const { enqueueSnackbar } = useSnackbar();
  const { editItem, editId } = props;
  const { profileEntrySchema, profileUpdate, handleFileChange } =
    useProfileForm({
      existingImageUrl: { url: get(editItem, "image_url", "") },
    });

  const popover = usePopover();
  const [imageData, setImageData] = useState(
    size(editItem?.image_url) == 0 ? null : editItem.image_url
  );
  const defaultValues = useMemo(() => ({
    name: get(editItem, "name", ""),
    speciality: get(editItem, "speciality", ""),
    experience: get(editItem, "experience", ""),
    biography: get(editItem, "biography", ""),
    location_url: get(editItem, "location_url", ""),
    working_time: get(editItem, "working_time", ""),
    email: get(editItem, "email_id", ""),
    mobileNo: get(editItem, "mobile_no", ""),
  }));
  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
    control,
  } = useForm({
    resolver: joiResolver(profileEntrySchema),
    defaultValues,
  });

  const onlyNumbers = (e) => {
    e.target.value = e.target.value.replace(/[^0-9]/g, "");

    if (e.target.value.toString().length === 0) return;
    return (e.target.value = Math.max(0, parseInt(e.target.value))
      .toString()
      .slice(0, 10));
  };

  const onUserSubmit = useCallback(async () => {
    try {
      const res =
        get(editItem, "id", null) === null
          ? null
          : await profileUpdate({
              ...getValues(),
              id: get(editItem, "id", null),
            });
      if (res === true) {
        props.postSubmit();
      } else {
        enqueueSnackbar("Problem While Saving Profile Data", {
          variant: "error",
        });
      }
    } catch (err) {
      console.log("errr", err);
    }
  }, [profileUpdate]);

  const onlyCharacters = (e) => {
    e.target.value = e.target.value.replace(/[^a-zA-Z ]*$/, "");

    return e.target.value;
  };
  const fileUpload = (file) => {
    handleFileChange(file);
    popover.onClose();
    const reader = new FileReader();

    reader.onload = () => {
      setImageData(reader.result);
    };

    reader.readAsDataURL(file);
  };

  return (
    <React.Fragment>
      <Typography variant="h5" gutterBottom>
        Profile Form
      </Typography>
      <Divider sx={{ mb: 3 }} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            id="name"
            name="name"
            label="Doctor Name"
            fullWidth={true}
            variant="outlined"
            size="small"
            inputProps={{
              maxLength: 50,
            }}
            {...register("name")}
            autoComplete="false"
            error={size(errors?.name?.message) > 0 ? true : false}
            helperText={
              size(errors?.name?.message) > 0 ? errors?.name?.message : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            id="speciality"
            name="speciality"
            label="Speciality"
            onInput={(e) => onlyCharacters(e)}
            fullWidth={true}
            variant="outlined"
            size="small"
            inputProps={{
              maxLength: 50,
            }}
            {...register("speciality")}
            autoComplete="false"
            error={size(errors?.speciality?.message) > 0 ? true : false}
            helperText={
              size(errors?.speciality?.message) > 0
                ? errors?.speciality?.message
                : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            id="name"
            name="email"
            label="Email"
            fullWidth={true}
            variant="outlined"
            size="small"
            inputProps={{
              maxLength: 50,
            }}
            {...register("email")}
            autoComplete="false"
            error={size(errors?.email?.message) > 0 ? true : false}
            helperText={
              size(errors?.email?.message) > 0 ? errors?.email?.message : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            id="speciality"
            name="mobileNo"
            label="Mobile No."
            onInput={(e) => onlyNumbers(e)}
            fullWidth={true}
            variant="outlined"
            size="small"
            inputProps={{
              maxLength: 50,
            }}
            {...register("mobileNo")}
            autoComplete="false"
            error={size(errors?.mobileNo?.message) > 0 ? true : false}
            helperText={
              size(errors?.mobileNo?.message) > 0
                ? errors?.mobileNo?.message
                : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            id="biography"
            name="biography"
            label="Biography"
            onInput={(e) => onlyCharacters(e)}
            fullWidth={true}
            variant="outlined"
            size="small"
            inputProps={{
              maxLength: 50,
            }}
            {...register("biography")}
            autoComplete="false"
            error={size(errors?.biography?.message) > 0 ? true : false}
            helperText={
              size(errors?.biography?.message) > 0
                ? errors?.biography?.message
                : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            id="location_url"
            name="location_url"
            label="Location Url"
            onInput={(e) => onlyCharacters(e)}
            fullWidth={true}
            variant="outlined"
            size="small"
            inputProps={{
              maxLength: 50,
            }}
            {...register("location_url")}
            autoComplete="false"
            error={size(errors?.location_url?.message) > 0 ? true : false}
            helperText={
              size(errors?.location_url?.message) > 0
                ? errors?.location_url?.message
                : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            id="working_time"
            name="working_time"
            label=" Working Time"
            fullWidth={true}
            variant="outlined"
            size="small"
            inputProps={{
              maxLength: 50,
            }}
            {...register("working_time")}
            autoComplete="false"
            error={size(errors?.working_time?.message) > 0 ? true : false}
            helperText={
              size(errors?.working_time?.message) > 0
                ? errors?.working_time?.message
                : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            id="experience"
            name="experience"
            label="Experience"
            onInput={(e) => onlyNumbers(e)}
            fullWidth={true}
            variant="outlined"
            size="small"
            inputProps={{
              maxLength: 50,
            }}
            {...register("experience")}
            autoComplete="false"
            error={size(errors?.experience?.message) > 0 ? true : false}
            helperText={
              size(errors?.experience?.message) > 0
                ? errors?.experience?.message
                : ""
            }
          />
        </Grid>
        {/* <Grid item xs={12} sm={12}>
          <TextField type="file" hidden={true}>
            <ImageIcon />
          </TextField>
        </Grid> */}
        {imageData === null ? (
          <Grid item xs={12} sm={12} mt={3}>
            <IconButton
              className="p-0"
              style={{ width: "100%", borderRadius: "0px" }}
              color="primary"
            >
              <label
                htmlFor="upload"
                onMouseEnter={(e) => (e.target.style.padding = "1rem")}
                style={{
                  width: "100%",
                  height: "210px",
                  border: "2px dashed #1976d2",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <>
                  <AddAPhotoIcon style={{ fontSize: "3rem" }} />
                  <input
                    accept="image/*"
                    onChange={(e) => fileUpload(e.target.files[0])}
                    type="file"
                    hidden={true}
                    id="upload"
                  />
                </>
              </label>
            </IconButton>
          </Grid>
        ) : (
          <Grid
            item
            xs={12}
            sm={12}
            sx={{ width: "100%", textAlign: "center" }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "end",
              }}
            >
              <IconButton className="iconbtn" onClick={popover.onOpen}>
                <Iconify icon="eva:more-vertical-fill" />
              </IconButton>
            </Box>
            <img
              className="uploadedImg"
              src={imageData}
              style={{
                marginBottom: "10px",
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            />

            <CustomPopover
              open={popover.open}
              onClose={popover.onClose}
              arrow="right-top"
              sx={{ width: 100, ml: 1, marginTop: "30px" }}
            >
              <IconButton
                style={{
                  width: "100%",
                  borderRadius: "0px",
                  fontSize: "16px",
                  fontWeight: "normal",
                }}
                color="primary"
                sx={{ padding: 0 }}
              >
                <label
                  htmlFor="uploadagain"
                  style={{
                    width: "100%",
                    padding: 7,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      cursor: "pointer",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Iconify icon="solar:pen-bold" />
                      <span style={{ marginLeft: "10px" }}>Edit</span>
                    </div>

                    <input
                      className="uploadInput"
                      accept="image/*"
                      onChange={(e) => fileUpload(e.target.files[0])}
                      type="file"
                      hidden={true}
                      id="uploadagain"
                    />
                  </div>
                </label>
              </IconButton>
              <div
                onClick={() => setImageData(null)}
                style={{
                  display: "flex",
                  marginLeft: "5px",
                  alignItems: "center",
                  cursor: "pointer",
                  color: "red",
                }}
              >
                {/* <Iconify icon="solar:trash-bin-trash-bold" />
                <span style={{ marginLeft: "10px" }}>Delete</span> */}
              </div>
            </CustomPopover>
          </Grid>
        )}

        {/* <Grid item xs={3} sm={3}>
          <Typography>
            <FormControlLabel
              sx={{ mt: -1 }}
              control={
                <Checkbox
                  sx={{
                    "&.Mui-checked": {
                      color: color.button,
                    },
                  }}
                  id="is_labour"
                  checked={status}
                  onChange={handleStatusComboChange}
                />
              }
              label="Active"
            />
          </Typography>
        </Grid> */}
        <Grid container direction="row">
          <Grid item xs={12} sm={12}>
            <Stack direction="row" justifyContent="end">
              <Button
                variant="contained"
                sx={{
                  height: 40,
                  borderRadius: 3,
                  m: 1,
                  backgroundColor: color.button,
                  "&:hover": {
                    backgroundColor: color.button,
                  },
                }}
                type="submit"
                onClick={(e) => {
                  e.preventDefault();
                  handleSubmit(onUserSubmit)();
                }}
              >
                Save
              </Button>
              <Button
                sx={{
                  height: 40,
                  borderRadius: 3,
                  m: 1,
                  borderColor: color.button,
                  color: color.button,
                  "&:hover": {
                    color: color.button,
                  },
                }}
                variant="outlined"
                onClick={(e) => {
                  e.preventDefault();
                  props.postSubmit();
                }}
              >
                Cancel
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
